import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var FailedDeliveryAttempt = function FailedDeliveryAttempt() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ObOGqM",
    defaultMessage: [{
      "type": 0,
      "value": "Lorsqu'une tentative de livraison échoue, il est essentiel d'agir rapidement pour remédier à la situation afin que votre colis parvienne bien au commerçant. Voici ce que vous pouvez faire :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Dk6+pO",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Contactez le transporteur :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " contactez immédiatement le transporteur pour connaître la raison de l'échec de la tentative de livraison et essayer d'organiser une nouvelle livraison."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fHRo9Q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Envoyez un message à votre commerçant :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " informez-le de l'échec de la tentative de livraison et des nouvelles informations ou modifications susceptibles d'affecter le calendrier de livraison."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "v4mWlX",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vérifiez l'adresse de livraison :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " vérifiez l'adresse de livraison fournie par le commerçant. En cas de divergence, demandez au commerçant de confirmer l'adresse correcte."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "/2TRVS",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Organisez une nouvelle livraison :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " une fois l'adresse confirmée et les éventuels problèmes résolus, contactez le transporteur pour planifier une nouvelle livraison dès que possible."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};